module.exports = __webpack_public_path__ + "static/img/pengyouquan.e9d1ee81.png";